import React, { Component } from 'react'
import { Card, ProgressBar, CardDeck, Row, Badge } from 'react-bootstrap'
import { Icon } from 'semantic-ui-react'
import './css/skills.css'
import skill from './json/skills.json'

export class skills extends Component {
  constructor (props) {
    super(props)

    this.state = {
      skillset: [],
      myDate: new Date()
    }
  }

  componentDidMount () {
    this.setState({ skillset: skill })
  }

  render () {
    const myskill = this.state.skillset.map((item) => {
      return (
        <div className='col-6 col-md-12 col-lg-6 col-xl-4 mb-3' data-aos='fade-up' key={item.index}>
          <Card>
            <div className='container'>
              <div className='Row'>
                <div className='col-md-3 offset-3'>
                  <Card.Img className='img' variant='top' src={item.image} />
                </div>
              </div>
            </div>
            <Card.Body>
              <Badge variant='success'>{item.certified}</Badge>
              <Card.Title>{item.Name} -{'>'} Fuel: {item.skill}%</Card.Title>
              <ProgressBar now={item.skill} animated />
            </Card.Body>
            <Card.Footer>
              <small className='text-muted'>Working Since: {item.start}</small>
            </Card.Footer>
          </Card>
        </div>
      )
    })

    return (
      <>
        <div id='img2'>
          <div id='skill'>
            <div>
              <h1>Welcome to my</h1>
              <Row className='justify-content-center'>
                <Icon name='compass' size='big' />
                <h3>Skills</h3>
              </Row>
            </div>
          </div>
        </div>
        <div className='container cardlay'>
          <div className='row'>
            <CardDeck>
              {myskill}
            </CardDeck>
          </div>
        </div>
      </>
    )
  }
}

export default skills
